import React from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { selectCurrentUser } from '@stores/usersSlice';

const Authorize = ({ requires, children, unauthorizedError }) => {
  return hasAccess(requires) ? children : unauthorizedError;
};

export const hasAccess = (permissions) => {
  const currentUser = useSelector(selectCurrentUser);
  return currentUser?.Permissions?.some((x) => permissions.includes(x));
};

Authorize.propTypes = {
  children: PropTypes.node.isRequired,
  requires: PropTypes.arrayOf(PropTypes.string).isRequired,
  unauthorizedError: PropTypes.node,
};

Authorize.defaultProps = {
  unauthorizedError: <></>,
};

export default Authorize;
